import React from "react";

const base = process.env.PUBLIC_URL || "";

/** Shared AlphaXCloud logo — wordmark or icon mark */
const BrandLogo = ({
  variant = "full",
  className = "",
  alt = "AlphaXCloud",
  height,
}) => {
  const src =
    variant === "icon"
      ? `${base}/assets/images/logo-icon.svg`
      : `${base}/assets/images/alphaxcloud.svg`;

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      height={height}
      style={height ? { height, width: "auto" } : undefined}
    />
  );
};

export default BrandLogo;
